import { Component, Input, HostListener } from "@angular/core";
import { ProcessActionComponent } from "../../processAction";
import * as moment from "moment";
import { LoadingController, ModalController, Events } from "@ionic/angular";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { HttpApiService } from "../../../services/http-api/http-api.service";
import { ConfigService } from "../../../services/config/config.service";
import { ManageStoneInwardPage } from "../manage-stone-inward/manage-stone-inward.page";
import { ScanRFIDPage } from "../../../components/actions/scan-rfid/scan-rfid.page";

@Component({
  selector: "app-stone-inward",
  templateUrl: "./stone-inward.component.html",
  styleUrls: ["./stone-inward.component.scss"]
})
export class StoneInwardComponent implements ProcessActionComponent {
  @Input() data: any;

  public listOfStoneData: any = [];
  public status: any;
  public pageNumber = 0;
  public noOfRecords = 20;
  public totalPages: number;
  public count: number = 0;
  public userId: any;
  public voucherBookId: any;
  public page = "stoneInward";
  public option = "FACT. O/W NO WISE";
  public columns: any;
  public optionList = [];

  //get inward data;

  public pendingTotalStones = 0;
  public totalStones = 0;
  public pendingTotalCts = 0;
  public totalCts = 0;
  public pendingSingleStones = 0;
  public totalSingleStones = 0;
  public pendingSingleStonesCts = 0;
  public totalSingleStonesCts = 0;
  public pendingMixStones = 0;
  public totalMixStones = 0;
  public pendingMixStonesCts = 0;
  public totalMixStonesCts = 0;

  //view variable

  public keyFun: any = true;
  public openView: any = false;

  constructor(
    private authService: AuthenticationService,
    public loadingController: LoadingController,
    public httpApiService: HttpApiService,
    public modalCtrl: ModalController,
    public configService: ConfigService,
    public event: Events
  ) {
  }


  ngOnInit() {
    this.optionList = [{ id: 1, name: 'FACT. O/W NO WISE', isSelected: true }, { id: 2, name: 'SINGLE INWARD', isSelected: false }, { id: 3, name: 'BULK INWARD', isSelected: false }, { id: 4, name: 'PROGRAM WISE', isSelected: false }]
    this.getInwardStatus();
    this.viewDataByOption(this.optionList);
    this.event.subscribe('Inward', (item) => {
      this.getInwardStatus();
      this.viewDataByOption(this.optionList);
    })
  }

  ngOnDestroy() {
    this.event.unsubscribe('Inward');
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.keyFun) {
      if (event.keyCode == 86) {
        this.openView = true;
      }
    }
  }

  async closeViewFun() {
    this.openView = false;
  }

  async viewDataByOption(optionList) {
    optionList.forEach(el => {
      if (el.isSelected == true) {
        this.option = el.name;
      }
    })
    console.log(this.option)

    if (this.option == 'FACT. O/W NO WISE') {
      this.pageNumber = 0;
      this.noOfRecords = 20;
      this.columns = [
        { name: "Voucher No", prop: "" },
        { name: "Inward Date & Time", prop: "createdDate" },
        { name: "Inward from", prop: "companyName" },
        { name: "Fact. O/w No.", prop: "factoryOutWNo" },
        { name: "Fact. O/w Date", prop: "factoryOutWDate" },
        { name: "Pending", prop: "" },
        { name: "Pending Ct.", prop: "" }
      ];

      this.getAllPendingStoneInward(this.pageNumber, this.noOfRecords);
    } else if (this.option == 'PROGRAM WISE') {
      this.openView = false
      this.columns = [
        { name: "Program Name", prop: "progName" },
        { name: "Pending", prop: "" },
        { name: "Pending Ct.", prop: "" }
      ];
      this.getAllPendingStoneInwardProgramWise(this.pageNumber, this.noOfRecords);
    }
    else if (this.option == 'SINGLE INWARD') {
      this.openView = false
      this.columns = [
        { name: "StoneId", prop: "stoneId" },
        { name: "Color", prop: "color" },
        { name: "Shape", prop: "shape" },
        { name: "Ct.", prop: "stoneCts" },
        { name: "Clarity", prop: "clarity" },
        { name: "Cut", prop: "cut" },
        { name: "Polish", prop: "polishCode" },
        { name: "Symmetry", prop: "symmetryCode" },
        { name: "Fluorescence", prop: "fluorescence" },
        { name: "Lab", prop: "lab" },
        { name: "Inward Date & Time", prop: "modifiedDate" },
      ];
      this.findIncomingByVoucherTypeAndTransType('SS', this.pageNumber, this.noOfRecords);
    }
    else if (this.option == 'BULK INWARD') {
      this.openView = false
      this.columns = [
        { name: "StoneId", prop: "stoneId" },
        { name: "Color", prop: "color" },
        { name: "Shape", prop: "shape" },
        { name: "Ct.", prop: "stoneCts" },
        { name: "Clarity", prop: "clarity" },
        { name: "Cut", prop: "cut" },
        { name: "Polish", prop: "polishCode" },
        { name: "Symmetry", prop: "symmetryCode" },
        { name: "Fluorescence", prop: "fluorescence" },
        { name: "Inward Date & Time", prop: "modifiedDate" },
      ];
      this.findIncomingByVoucherTypeAndTransType('MIX', this.pageNumber, this.noOfRecords);
    }
  }

  pendingPackets(row) {
    if (!!row.pendingPackets) {
      return row.pendingPackets;
    } else {
      return row.totalPackets;
    }
  }

  pendingCarat(row) {
    if (!!row.pendingCarat) {
      return parseFloat(row.pendingCarat.toFixed(2));
    } else {
      return parseFloat(row.totalCarat.toFixed(2));
    }
  }

  async getInwardStatus() {
    let res: any;
    res = await this.httpApiService.getInwardStatus(this.data.voucherType);
    let data = res.json();
    if (res.status == 401) {
      this.authService.logout();
    } else if (res.status == 500) {
      await this.configService.showToast("error", data.error);
    } else {
      if (res.status == 400) {
        await this.configService.showToast("error", data.error);
      } else {
        if (data.data) {
          let dataValue = data.data;
          this.pendingTotalStones = dataValue.pendingTotalStones;
          this.totalStones = dataValue.totalStones;
          this.pendingTotalCts = dataValue.pendingTotalCts ? dataValue.pendingTotalCts : 0.00;
          this.totalCts = dataValue.totalCts ? dataValue.totalCts : 0.00;
          this.pendingSingleStones = dataValue.pendingSingleStones;
          this.totalSingleStones = dataValue.totalSingleStones;
          this.pendingSingleStonesCts = dataValue.pendingSingleStonesCts ? dataValue.pendingSingleStonesCts : 0.00;
          this.totalSingleStonesCts = dataValue.totalSingleStonesCts ? dataValue.totalSingleStonesCts : 0.00;
          this.pendingMixStones = dataValue.pendingMixStones;
          this.totalMixStones = dataValue.totalMixStones;
          this.pendingMixStonesCts = dataValue.pendingMixStonesCts ? dataValue.pendingMixStonesCts : 0.00;
          this.totalMixStonesCts = dataValue.totalMixStonesCts ? dataValue.totalMixStonesCts : 0.00;


        }
      }
    }
  }

  async getAllPendingStoneInward(pageNumber, noOfRecords) {
    await this.configService.showLoader();
    let res: any;
    console.log(this.data.voucherType);
    res = await this.httpApiService.getAllPendingStoneInward(
      this.data.voucherType,
      pageNumber,
      noOfRecords
    );
    let data = res.json();
    await this.loadingController.dismiss();
    if (res.status == 401) {
      this.authService.logout();
    } else if (res.status == 500) {
      await this.configService.showToast("error", data.error);
    } else {
      if (res.status == 400) {
        await this.configService.showToast("error", data.error);
      } else {
        this.listOfStoneData = data.data.content;
        console.log(this.listOfStoneData);
        this.totalPages = data.data.totalPages;
        this.count = data.data.totalElements;
      }
    }
  }

  async getAllPendingStoneInwardProgramWise(pageNumber, noOfRecords) {
    await this.configService.showLoader();
    let res: any;
    console.log(this.data.voucherType);
    res = await this.httpApiService.getAllPendingStonesProgramWise(
      this.data.voucherType,
      pageNumber,
      noOfRecords
    );
    let data = res.json();
    await this.loadingController.dismiss();
    if (res.status == 401) {
      this.authService.logout();
    } else if (res.status == 500) {
      await this.configService.showToast("error", data.error);
    } else {
      if (res.status == 400) {
        await this.configService.showToast("error", data.error);
      } else {
        this.listOfStoneData = data.data.content;
        console.log(this.listOfStoneData);
        this.totalPages = data.data.totalPages;
        this.count = data.data.totalElements;
      }
    }
  }

  async findIncomingByVoucherTypeAndTransType(type, pageNumber, noOfRecords) {
    await this.configService.showLoader();
    let res: any;
    console.log(this.data.voucherType);
    res = await this.httpApiService.findIncomingByVoucherTypeAndTransType(
      pageNumber,
      noOfRecords,
      this.data.voucherType,
      type
    );
    let data = res.json();
    await this.loadingController.dismiss();
    if (res.status == 401) {
      this.authService.logout();
    } else if (res.status == 500) {
      await this.configService.showToast("error", data.error);
    } else {
      if (res.status == 400) {
        await this.configService.showToast("error", data.error);
      } else {
        this.listOfStoneData = data.data.content;
        console.log(this.listOfStoneData);
        this.totalPages = data.data.totalPages;
        this.count = data.data.totalElements;
      }
    }
  }

  async openConfirmationModal(item) {
    if (item.type == "mouseenter") {
      //Stop event propagation and let onSelect() work
      item.event.stopPropagation();
    } else {
      if (!this.openView && (this.option == 'FACT. O/W NO WISE' || this.option == 'PROGRAM WISE')) {
        this.keyFun = false;
        this.status = item.row.id;
        const modal = await this.modalCtrl.create({
          component: ManageStoneInwardPage,
          backdropDismiss: false,
          componentProps: {
            data: item.row,
            option: this.option
          },
          cssClass: 'requestPage'
        });
        modal.onDidDismiss().then((d: any) => this.handleModalDismiss(d));
        return await modal.present();
      } else {
        this.keyFun = true;
      }
    }
  }

  async handleModalDismiss(d) {
    this.keyFun = true;
    if (d.data == 1) {
      this.getInwardStatus();
      this.status = null;
      if (this.option == 'FACT. O/W NO WISE') {
        this.getAllPendingStoneInward(this.pageNumber, this.noOfRecords);
      }
      else if (this.option == 'PROGRAM WISE') {
        this.getAllPendingStoneInwardProgramWise(this.pageNumber, this.noOfRecords)
      }
    } else {

    }

  }

  async setPage(currentPage) {
    this.pageNumber = currentPage.offset;
    if (this.option == 'FACT. O/W NO WISE') {
      this.getAllPendingStoneInward(currentPage.offset, this.noOfRecords);
    }
    else if (this.option == 'PROGRAM WISE') {
      this.getAllPendingStoneInwardProgramWise(currentPage.offset, this.noOfRecords)
    }
    else if (this.option == 'SINGLE INWARD') {
      this.findIncomingByVoucherTypeAndTransType('SS', currentPage.offset, this.noOfRecords)
    }
    else if (this.option == 'BULK INWARD') {
      this.findIncomingByVoucherTypeAndTransType('MIX', currentPage.offset, this.noOfRecords)
    }
  }

  async openScanModel() {
    if (!this.openView) {
      this.keyFun = false;
      const modal = await this.modalCtrl.create({
        component: ScanRFIDPage,
        backdropDismiss: false,
        componentProps: {
          type: "receive"
        },
        cssClass: "largePage"
      });
      modal.onDidDismiss().then((d: any) => this.handleScanModalDismiss(d));
      return await modal.present();
    } else {
      this.keyFun = true;
    }
  }

  async handleScanModalDismiss(d) {
    this.getInwardStatus();
    this.keyFun = true;
    this.status = null;
    if (this.option == 'FACT. O/W NO WISE') {
      this.getAllPendingStoneInward(this.pageNumber, this.noOfRecords);
    } else if (this.option == 'PROGRAM WISE') {
      this.getAllPendingStoneInwardProgramWise(this.pageNumber, this.noOfRecords)
    } else if (this.option == 'SINGLE INWARD') {
      this.findIncomingByVoucherTypeAndTransType('SS', this.pageNumber, this.noOfRecords)
    } else if (this.option == 'BULK INWARD') {
      this.findIncomingByVoucherTypeAndTransType('MIX', this.pageNumber, this.noOfRecords)
    }
  }
}
